// extracted by mini-css-extract-plugin
export default {"sticky--top":"Notifications_sticky--top__UkCIM"};